const formatDate = (dates) => {
  if (dates !== null) {
    const day1 = new Date(dates);
    return `${day1.toLocaleString('en-US', { month: 'long' })} ${day1.getDate()}`;
  }
  return 'undefined';
};

const formatTime = (dateTime) => {
  const date = new Date(dateTime);
  const hours = date.getHours();
  const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const meridiem = hours >= 12 ? 'PM' : 'AM';
  return `${hours > 12 ? hours - 12 : hours}:${minutes} ${meridiem}`;
};

export {
  formatDate,
  formatTime,
};
